<div class="overlay">
    <div class="modal-container">
        <div class="modal-header">
          <h2>Sensor Threshold Value</h2>
        </div>
        
        <div class="modal-body">
          <form [formGroup]="thresholdForm" (ngSubmit)="onSubmit()">
            <div class="note">
              <p>Note: Vibration severity thresholds as per the ISO 10816. Users can change the thresholds, if so required</p>
            </div>
      
            <div class="table-container">
              <table class="threshold-table">
                <thead>
                  <tr>
                    <th class="sensor-group-column">Sensor Group</th>
                    <th class="range-column" colspan="2">Range</th>
                    <th class="threshold-column">Green</th>
                    <th class="threshold-column">Yellow</th>
                    <th class="threshold-column">Red</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Flow Row -->
                  <tr formGroupName="flow">
                    <td style="text-align: center;">Flow</td>
                    <td>
                      <input type="number" formControlName="baseValue" class="input-value" placeholder="0">
                    </td>
                    <td>
                      <input type="number" formControlName="maxValue" class="input-value" placeholder="100">
                    </td>
                    <td>
                      <div class="percent-input">
                        <input type="number" formControlName="green" class="input-value" placeholder="50">
                        <span class="percent-symbol">%</span>
                      </div>
                    </td>
                    <td>
                      <div class="percent-input">
                        <input type="number" formControlName="yellow" class="input-value" placeholder="75">
                        <span class="percent-symbol">%</span>
                      </div>
                    </td>
                    <td>
                      <div class="percent-input">
                        <input type="number" formControlName="red" class="input-value" placeholder="90">
                        <span class="percent-symbol">%</span>
                      </div>
                    </td>
                  </tr>
      
                  <!-- Error messages for Flow -->
                  <tr *ngIf="getFormGroupError('flow')" class="error-row">
                    <td colspan="6" class="error-message">{{ getFormGroupError('flow') }}</td>
                  </tr>
      
                  <!-- Pressure Row -->
                  <tr formGroupName="pressure">
                    <td style="text-align: center;">Pressure</td>
                    <td>
                      <input type="number" formControlName="baseValue" class="input-value" placeholder="0">
                    </td>
                    <td>
                      <input type="number" formControlName="maxValue" class="input-value" placeholder="100">
                    </td>
                    <td>
                      <div class="percent-input">
                        <input type="number" formControlName="green" class="input-value" placeholder="50">
                        <span class="percent-symbol">%</span>
                      </div>
                    </td>
                    <td>
                      <div class="percent-input">
                        <input type="number" formControlName="yellow" class="input-value" placeholder="75">
                        <span class="percent-symbol">%</span>
                      </div>
                    </td>
                    <td>
                      <div class="percent-input">
                        <input type="number" formControlName="red" class="input-value" placeholder="90">
                        <span class="percent-symbol">%</span>
                      </div>
                    </td>
                  </tr>
      
                  <!-- Error messages for Pressure -->
                  <tr *ngIf="getFormGroupError('pressure')" class="error-row">
                    <td colspan="6" class="error-message">{{ getFormGroupError('pressure') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
      
            <!-- <div class="comment-section">
              <textarea placeholder="...comment" class="comment-input" rows="4"></textarea>
            </div> -->
      
            <div class="modal-footer">
              <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
              <button type="submit" [disabled]="thresholdForm.invalid || thresholdForm.pristine" class="btn btn-save">Save</button>
            </div>
          </form>
        </div>
      </div>
</div>